import { render, staticRenderFns } from "./InscricaoForm_v3.vue?vue&type=template&id=674419c1&scoped=true"
import script from "./InscricaoForm_v3.vue?vue&type=script&lang=js"
export * from "./InscricaoForm_v3.vue?vue&type=script&lang=js"
import style0 from "./InscricaoForm_v3.vue?vue&type=style&index=0&id=674419c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674419c1",
  null
  
)

export default component.exports